import React from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header.js';
import LineChart from './LineChart.js';
import DataTable from './DataTable.js';
import { getTeam, getProduct, getAuthor, getLanguage, getHumanLanguage, getList } from './DataContextProvider.js';

export default function ItemDashboard({ item, title, location, countries, withSplits, children }) {
  const [name, setName] = React.useState('');
  const { id } = useParams();
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '';

  let filters = {};
  filters[item] = [id];

  React.useEffect(() => {
    let getFunc;
    switch (title) {
      case 'Team': getFunc = getTeam; break;
      case 'Product': getFunc = getProduct; break;
      case 'Author': getFunc = getAuthor; break;
      case 'Computer Language': getFunc = getLanguage; break;
      case 'Human Language': getFunc = getHumanLanguage; break;
      case 'Country': getFunc = async (id) => { return {name: countries[id]}; }; break;
      case 'Publication Month': getFunc = async (id) => { return {name: id}; }; break;
      case 'Publication Quarter': getFunc = async (id) => { return {name: id}; }; break;
      case 'Publication Year': getFunc = async (id) => { return {name: id}; }; break;
      case 'List': getFunc = getList; break;
      default: getFunc = null;
    }
    if (getFunc) {
      getFunc(id).then(data => {
        setName(data.name);
      });
    }
  }, [id, countries, title]);

  const addRedirect = (id, flag, item) => {
    return (
      <>
        {item}
        &nbsp;
        {flag && <><img alt="" src="/sendgrid.png" />&nbsp;</>}
        <a target="_blank" rel="noreferrer" href={apiBase + `/api/articles/${id}/redirect`}><img alt="" src="/external-link.svg" className="link" /></a>
      </>
    );
  };

  return (
    <>
      <Header title={title + ': ' + name} location={location}>
        {children}
      </Header>
      <LineChart filters={filters} withTotals={true} withSplits={withSplits} />
      <DataTable item="articles" title="Article" filters={filters} paginate={true} extra={addRedirect} />
    </>
  );
}
